<app-element-multi-select [displayLabel]="'Product'"
                          [dataType]="DataType.Default"
                          [cssClasses]="cssClasses"
                          [selectedValues]="selectedProducts"
                          [defaultValues]="productDefaults()"
                          [options]="productNames()"
                          [requiredErrorMessage]="'At least 1 product must be selected'"
                          (selectedValuesChange)="onSelectionChanged($event)">
</app-element-multi-select>
